import { useEffect, useState, useCallback } from "react";
import { api, apiError } from "@/lib/api";
import { ScrollText } from "lucide-react";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const load = useCallback(() => {
    api.get("/audit?limit=300").then((r) => setLogs(r.data)).catch((e) => console.error(apiError(e)));
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-6 max-w-5xl">
      <div>
        <h1 className="font-head text-3xl font-bold tracking-tight flex items-center gap-2">
          <ScrollText className="h-6 w-6 text-indigo-400" /> Audit Log
        </h1>
        <p className="text-muted-foreground mt-1">Every prepare, approve and file action, with who did it and the filing reference (ARN). Entries cannot be edited or deleted.</p>
      </div>

      <div className="rounded-lg border border-border bg-card divide-y divide-border">
        {logs.map((l) => (
          <div key={l.id} data-testid="audit-log-entry-row" className="p-4 flex items-start gap-4">
            <div className="w-32 sm:w-40 shrink-0">
              <div className="font-mono text-xs text-muted-foreground">{new Date(l.timestamp).toLocaleString()}</div>
              <div className="mt-1 inline-flex items-center rounded border border-border px-1.5 py-0.5 text-[10px] font-mono uppercase tracking-wide text-indigo-300">{l.action.replace(/[._]/g, " ")}</div>
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm break-words [overflow-wrap:anywhere]">{l.detail}</div>
              <div className="font-mono text-xs text-muted-foreground mt-1 break-words [overflow-wrap:anywhere]">
                {l.actor_name} · {l.actor_role}
                {l.response?.arn && <span className="text-emerald-400"> · ARN {l.response.arn}</span>}
              </div>
            </div>
          </div>
        ))}
        {logs.length === 0 && <div className="p-6 text-muted-foreground font-mono text-sm">No audit entries yet.</div>}
      </div>
    </div>
  );
}
